module.exports = __webpack_public_path__ + "static/img/icon12.e826d62b.png";